import React from 'react';
import {
  Box,
  Button,
  Container,
  Paper,
  Typography,
  useMediaQuery,
  CircularProgress
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useAuth } from '../context/AuthContext';
import { useTheme as useAppTheme } from '../context/ThemeContext';

const LoginPage = () => {
  const { signIn, loading } = useAuth();
  const theme = useTheme();
  const { isDarkMode } = useAppTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const handleSignIn = () => {
    signIn();
  };

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      bgcolor: 'background.default',
      color: 'text.primary',
      transition: 'background-color 0.3s, color 0.3s'
    }}>
      <Container maxWidth="sm" sx={{ mt: isMobile ? 4 : 8, mb: 4, flexGrow: 1 }}>
        <Paper
          elevation={3}
          sx={{
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <img
            src={isDarkMode ? "/images/vitens-dark2.png" : "/images/vitens-dark2.png"}
            alt="Company Logo"
            width="200"
            style={{ marginBottom: 24 }}
          />
          
          <Typography variant="h4" component="h1" gutterBottom align="center">
            VCM (Vitens COMSOL Manager)
          </Typography>
          
          <Typography variant="h6" component="h2" gutterBottom align="center" color="text.secondary">
            AWS Server Manager - Version 1.0.0
          </Typography>
          
          <Typography variant="body1" paragraph align="center" sx={{ mt: 2 }}>
            Please sign in to access the COMSOL AWS Server Manager
          </Typography>
          
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleSignIn}
            disabled={loading}
            sx={{ mt: 3, mb: 2, py: 1.5, px: 4, minWidth: 120 }}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Sign In'}
          </Button>
        </Paper>
      </Container>

      <Box component="footer" sx={{ py: 2, bgcolor: 'background.paper', textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          © {new Date().getFullYear()} Vitens - CAPTAIN COMSOL AWS Instance Manager
        </Typography>
      </Box>
    </Box>
  );
};

export default LoginPage;
